import React from 'react';

const Table = ({ headers, data, renderRow }) => {
  return (
    <div style={{
      background: 'var(--color-background-primary)',
      border: '1px solid var(--color-border-tertiary)',
      borderRadius: 'var(--border-radius-lg)',
      overflow: 'hidden'
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: 'var(--color-background-secondary)' }}>
            {headers.map((header, idx) => (
              <th key={idx} style={{
                fontSize: '11px',
                color: 'var(--color-text-tertiary)',
                textAlign: 'left',
                padding: '12px 16px',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                borderBottom: '1px solid var(--color-border-tertiary)'
              }}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx} style={{ borderBottom: idx === data.length - 1 ? 'none' : '1px solid var(--color-border-tertiary)' }}>
              {renderRow(item, idx)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
